import { useHasRunningEnvironment } from "./useHasRunningEnvironment";

/** The Compute Envs sidebar label, with a running-environment dot to match the legacy nav's status indicator. */
export const ComputeEnvsNavLabel = ({ workbenchId }: { workbenchId: number | null }) => {
  const hasRunningEnvironment = useHasRunningEnvironment(workbenchId);

  return (
    <span className="flex w-full items-center justify-between gap-1.5">
      Compute Envs
      {hasRunningEnvironment && (
        <span
          aria-label="Running"
          className="size-2 shrink-0 rounded-full bg-green-600 dark:bg-green-500"
        />
      )}
    </span>
  );
};
